import React, { createContext, useContext, useEffect, useState } from "react";
import { socket } from "../utils/customFn";
import { SocketContext } from ".";
import { useSelector } from "react-redux";

export const SocketProvider = ({ children }) => {
  const [adminOnline, setAdminOnline] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0); 
  const [verificationRequestCount, setVerificationRequestCount] = useState(0); 
  const { profileData } = useSelector((state) => state.userAuth);

  useEffect(() => {
    if (!profileData?.id) return;

    const handleConnect = () => {
      socket.emit("online_admin", profileData.id);
      setAdminOnline(true);
    };

    const handleDisconnect = () => {
      setAdminOnline(false);
    };

    const handleUnreadCount = (count) => {
      setUnreadCount(count);
    };

    const handleVerificationRequest = (count) => {
      setVerificationRequestCount(count);
    };

    socket.on("connect", handleConnect);
    socket.on("disconnect", handleDisconnect);
    socket.on("admin:unread_count", handleUnreadCount); 
    socket.on("admin:verification_request_count", handleVerificationRequest);
    
    if (socket.connected) {
        
      socket.emit("online_admin", profileData.id);
      
      setAdminOnline(true);
    }

    return () => {
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
      socket.off("admin:unread_count", handleUnreadCount); 
    };
  }, [profileData?.id]);

  return (
    <SocketContext.Provider value={{ 
      adminOnline, 
      socket,
      unreadCount, 
      setUnreadCount ,
      verificationRequestCount
    }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);